import axios from 'axios'
import { AuthModel, NewUserRegistrationModel, UserModel } from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/dashboard/verify`
export const LOGIN_URL = `${API_URL}/dashboard/login`
export const REGISTER_URL = `${API_URL}/accounts/UserSignUp`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

// Server should return AuthModel
export function login(formData: FormData) {
  return axios.post<AuthModel>(LOGIN_URL, formData)
}

// Server should return AuthModel
export function register(
  email: string,
  firstName: string,
  lastName: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    firstName: firstName,
    lastName: lastName,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{ result: boolean }>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken() {
  const urlParams = new URLSearchParams(window.location.search)
  const token = String(urlParams.get('token'))
  return axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
}

//Registration

export function NewUserRegistration() {
  return axios.get<NewUserRegistrationModel>(REGISTER_URL)
}
